import { useEffect, useState } from "react";

const useFullScreen = () => {
  const [fullScreen, setFullScreen] = useState<boolean>(false);

  const requestFullScreen = (element) => {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    } else {
      setFullScreen(true);
      window.scrollTo(0, 0);
      element.style.zIndex = "99999";
      element.style.overflow = "hidden";
      element.style.height = "100vh";
    }
  };

  const exitFullScreen = (element) => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    } else {
      setFullScreen(false);
      element.style.zIndex = "1";
      element.style.overflow = "auto";
      element.style.height = "auto";
    }
  };

  const toggleFullScreen = () => {
    const element = document.getElementById("tldraw-live-session");
    if (!element) return;
    if (fullScreen) {
      exitFullScreen(element);
    } else {
      requestFullScreen(element);
    }
  };

  const fullScreenChange = () => {
    const doc = document as Document & {
      webkitFullscreenElement: Element;
    };
    if (
      doc.fullscreenElement !== null ||
      doc.webkitFullscreenElement !== null
    ) {
      setFullScreen(true);
    } else {
      setFullScreen(false);
    }
  };

  useEffect(() => {
    try {
      document.addEventListener("fullscreenchange", fullScreenChange);
    } catch (e) {
      console.error(e);
    }

    return () => {
      document.removeEventListener("fullscreenchange", fullScreenChange);
    };
  }, []);

  return { fullScreen, toggleFullScreen };
};

export default useFullScreen;
